import { defineSong } from '../types';

export default defineSong({
  id: 'sonbahar',
  title: 'Sonbahar Kahvesi',
  level: 3,
  key: 'C',
  bpm: 84,
  beats: 4,
  pattern: 'D--UD-U-',
  style: 'Caz',
  desc: "7'li akorlarla ii–V–I. Köprüde E7 seni Am7'ye götürüyor.",
  palette: ['Cmaj7', 'Dm7', 'Em7', 'Fmaj7', 'G7', 'Am7', 'E7', 'A7'],
  sections: [
    { name: 'Giriş', bars: ['Cmaj7', 'Am7', 'Dm7', 'G7'] },
    { name: 'Kıta', bars: ['Cmaj7', 'Am7', 'Dm7', 'G7', 'Em7', 'Am7', 'Dm7', 'G7'] },
    { name: 'Köprü', bars: ['Fmaj7', 'Fmaj7', 'E7', 'Am7', 'Dm7', 'Dm7', 'G7', 'G7'] },
    { name: 'Son', bars: ['Cmaj7', 'Am7', 'Dm7', 'G7', 'Cmaj7'] },
  ],
  // Original lyrics written for kulaktan.com; each word with its length in beats.
  lyrics: [
    { bar: 5, text: 'Köşedeki:3 masada:2 iki:1 fincan:2' },
    { bar: 7, text: 'Camda:2 sonbahar:3 yaprakları:3' },
    { bar: 9, text: 'Plakta:2 eski:2 bir:1 caz:1 çalar:2' },
    { bar: 11, text: 'Kahven:2 soğumasın,:3 otur:1 biraz:2' },
    { bar: 13, text: 'Yağmur:2 başlar:2 usulca:4' },
    { bar: 15, text: 'Şemsiyeler:4 açılır:4' },
    { bar: 17, text: 'Biz:2 burada,:2 sıcacık:4' },
    { bar: 19, text: 'Zaman:2 biraz:2 yavaşlar:4' },
    { bar: 21, text: 'Sonbahar:2 kahvesi,:2 sen:1 ve:1 ben:2' },
    { bar: 23, text: 'Bir:1 şarkı:2 daha,:1 son:1 bir:1 kez:2' },
  ],
});
